function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DAcApplicationUploadDocuments.css';
import React, { useEffect, useMemo, useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import UploadDocs from '../UploadDocs/UploadDocs';
import { fileToBase64, get, getDictionaryItem, getSizeFromBase64 } from '../../utils';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { createMapFromDictionary } from '../../utils/createMapFromDictionary';
import ActionPanel from './ActionPanel';
import { getAdditionalDocs, resubmitApplication } from './actions';
import Cookies from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { UploadDocument } from '../DAcApplication/components/actions';
import { getSessionId } from '../DAcApplication/utils';
import Loader from '../atoms/Loader/Loader';
const DAcApplicationUploadDocuments = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const history = useHistory();
  const [docsListLoading, setDocsListLoading] = useState(false);
  const [error, setError] = useState('');
  const [docs, setDocs] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [buttonInactive, setButtonInactive] = useState(false);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const title = get(props.fields, 'data.configuration.udTitle');
  const description = get(props.fields, 'data.configuration.udShortDescription');
  const supportedFiles = get(props.fields, 'data.configuration.udFileTypes.jss.value', '').split(',').filter(el => !!el);
  const maxFileSizeStr = get(props.fields, 'data.configuration.udFileSize.jss.value', '');
  const apiKey = get(props.fields, 'data.settings.apiKey.jss.value', '');
  const apiUrl = get(props.fields, 'data.settings.apiUrl.jss.value', '');
  const buttonSubmitUrl = get(props.fields, 'data.configuration.buttonSubmitUrl.jss.value.href', '');
  const maxFileSize = maxFileSizeStr && !Number.isNaN(Number(maxFileSizeStr)) ? Number(maxFileSizeStr) : undefined;
  const dictionary = get(props.fields, 'data.dictionaryUploadDocument', []);
  const navDictionary = get(props.fields, 'data.dictionaryNavigation.dictionaryValues', []);
  const navMapDictionary = createMapFromDictionary(navDictionary);
  const submitText = navMapDictionary.get('NavigationSubmit') || '';
  const {
    search
  } = useLocation();
  const userTokken = Cookies.get('token');
  const searchParams = new URLSearchParams(search);
  const applicationNumber = searchParams.get('appn');
  const sessionId = useMemo(() => getSessionId('additional-documents'), []);
  const setErrorDoc = (doc, file, error) => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: false,
          FileName: file.name,
          isUploaded: false,
          MimeType: file.type,
          size: file.size,
          percent: 0,
          error: error
        });
      } else {
        return el;
      }
    }));
  };
  const setLoadingDoc = (doc, file) => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: true,
          FileName: file.name,
          isUploaded: false,
          MimeType: file.type,
          percent: 0,
          size: file.size,
          error: ''
        });
      } else {
        return el;
      }
    }));
  };
  const setUpdatedDoc = doc => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: false,
          isUploaded: true,
          percent: 100
        });
      } else {
        return el;
      }
    }));
  };
  const getErrorMessage = res => {
    return (res && res.desc && (sitecoreContext.language === 'en' ? res.desc.en : res.desc.ar)).replaceAll(',', '\n') || res && (res.statusText || res.type) || getDictionaryItem(dictionary, 'SomethingWentWrong') || 'Something went wrong';
  };
  const deleteDoc = doc => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: false,
          FileName: undefined,
          isUploaded: false,
          MimeType: "",
          size: 0,
          percent: 0,
          error: undefined
        });
      } else {
        return el;
      }
    }));
  };
  const setProgress = (doc, file, percent) => {
    setDocs(docs => docs.map(el => {
      if (el.documentTypeId === doc.documentTypeId) {
        return _objectSpread(_objectSpread({}, el), {}, {
          isLoading: true,
          FileName: file.name,
          isUploaded: false,
          MimeType: file.type,
          percent,
          size: file.size,
          error: ''
        });
      } else {
        return el;
      }
    }));
  };
  const onUpload = async (document, file) => {
    const base64file = await fileToBase64(file);
    setLoadingDoc(document, file);
    setButtonLoading(true);
    try {
      const res = await UploadDocument({
        apiKey,
        apiUrl,
        sessionId,
        userTokken: userTokken
      }, applicationNumber || '', {
        document: base64file,
        documentTypeId: document.documentTypeId,
        FileName: file.name,
        MimeType: file.type
      }, val => setProgress(document, file, val));
      setButtonLoading(false);
      if (res.success === true) {
        setUpdatedDoc(document);
      } else {
        setErrorDoc(document, file, getErrorMessage(res));
      }
    } catch (err) {
      console.error(err);
      setErrorDoc(document, file, getDictionaryItem(dictionary, 'NetworkError') || 'Network error');
    }
  };
  const onUploadFileError = (document, file, error) => {
    setErrorDoc(document, file, getDictionaryItem(dictionary, error) || error);
  };
  const onSubmit = async () => {
    const res = await resubmitApplication({
      apiKey,
      apiUrl,
      sessionId,
      userTokken: userTokken
    }, applicationNumber || '');
    const {
      IsValid
    } = res;
    if (IsValid === 'True') history.push(buttonSubmitUrl);else getErrorMessage(res);
  };
  useEffect(() => {
    const invaliddoc = docs.find(_ref => {
      let {
        IsMandatory,
        isUploaded
      } = _ref;
      return IsMandatory && !isUploaded;
    });
    setButtonInactive(!!invaliddoc);
  }, [docs]);
  useEffect(() => {
    if (!applicationNumber) {
      return;
    }
    const load = async () => {
      setDocsListLoading(true);
      try {
        const res = await getAdditionalDocs({
          apiKey,
          apiUrl,
          sessionId,
          userTokken: userTokken
        }, applicationNumber);
        if (res.status === 200) {
          setDocs(get(res, 'DocumentsList', []));
        } else {
          setError(getErrorMessage(res));
        }
      } catch (err) {
        setError(getDictionaryItem(dictionary, 'NetworkError') || 'Network, error');
      }
      setDocsListLoading(false);
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-application-upload-documents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-application-upload-documents__module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-application-upload-documents__module-header"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "dac-application-upload-documents__title",
    tag: "h2",
    field: title.jss
  }), /*#__PURE__*/React.createElement(RichText, {
    className: "dac-application-upload-documents__description",
    tag: "p",
    field: description.jss
  })), docs.map(doc => /*#__PURE__*/React.createElement("div", {
    key: doc.documentTypeId,
    className: "dac-application-upload-documents__white-wrapper"
  }, /*#__PURE__*/React.createElement(UploadDocs, {
    onChange: file => onUpload(doc, file),
    dragNdropText: getDictionaryItem(dictionary, 'UploadFilesForEachPage'),
    fileUploadDescription: getDictionaryItem(dictionary, 'ApplicantsPassportMessage'),
    fileUploadTitle: `${sitecoreContext.language === 'ar' ? doc.documentNameAr : doc.documentNameEn} ${doc.IsMandatory ? ' *' : ''}`,
    files: doc.FileName ? [{
      id: doc.documentTypeId,
      filename: doc.FileName,
      size: doc.size || (doc.document ? getSizeFromBase64(doc.document) : undefined),
      error: doc.error,
      isLoading: doc.isLoading,
      isUploaded: doc.isUploaded,
      percent: doc.percent
    }] : [],
    successMessage: getDictionaryItem(dictionary, 'FileUploadedSuccessfully'),
    uploadButtonLabel: getDictionaryItem(dictionary, 'ChooseFile'),
    maxSizeKb: maxFileSize,
    onError: (error, file) => onUploadFileError(doc, file, error),
    maxSizeLabel: getDictionaryItem(dictionary, 'MaximumSize'),
    supportedFormatsLabel: getDictionaryItem(dictionary, 'SupportedFormat'),
    supportedFormats: supportedFiles,
    onDelete: () => deleteDoc(doc)
  }))), error && /*#__PURE__*/React.createElement("div", {
    className: "dac-application-upload-documents__white-wrapper error-message"
  }, error)), docsListLoading && /*#__PURE__*/React.createElement(Loader, null)), /*#__PURE__*/React.createElement(ActionPanel, {
    isLoading: docs.some(el => el.isLoading) || buttonLoading,
    submitText: submitText,
    inactive: buttonInactive,
    onSubmit: onSubmit
  }));
};
export default DAcApplicationUploadDocuments;
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1t6m5ps";
const rtlStyles = "r1fu83kp";
const ltrStyles = "l1itqgxi";